export enum EWorkerType {
  EMPLOYEE = "employee",
  CONTRACTOR = "contractor",
}
